import { render, staticRenderFns } from "./groupFitnessDashboardEventForm.vue?vue&type=template&id=6cd6ba22&scoped=true&xmlns=true"
import script from "./groupFitnessDashboardEventForm.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardEventForm.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardEventForm.vue?vue&type=style&index=0&id=6cd6ba22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd6ba22",
  null
  
)

export default component.exports